import { Outlet, useLocation, useNavigate } from 'react-router';

import { Spacing, Tabs, Typography } from 'enable-ui';

import { DashboardWrapper } from 'modules/dashboard/styles/dashboard';

import { PATH } from 'constants/path';

export const ProfilePage = () => {
  const tabs = [
    {
      children: <></>,
      key: `${PATH.PROFILE}/${PATH.USERNAME}`,
      label: 'User name',
    },
    {
      children: <></>,
      key: `${PATH.PROFILE}/${PATH.PASSWORD}`,
      label: 'Password',
    },
  ];
  const navigationTo = useNavigate();
  const location = useLocation();

  const onTabClick = (key: string) => {
    navigationTo(key);
  };

  return (
    <DashboardWrapper style={{ maxWidth: 800 }}>
      <Spacing spacing="xl" placement="bottom" type="margin">
        <Typography variant="h3" weight={500} style={{ fontSize: 26 }}>
          My profile
        </Typography>
      </Spacing>

      <Tabs
        variant="text"
        items={tabs}
        activeKey={location.pathname}
        onTabClick={onTabClick}
        tabItemStyle={{
          height: 44,
          background: 'transparent',
          fontSize: '18px',
          lineHeight: '26px',
          fontWeight: 600,
        }}
        isLine={true}
      />
      <div style={{ paddingTop: 16 }}>
        <Outlet />
      </div>
    </DashboardWrapper>
  );
};
